import React, { useState, useRef, useEffect } from "react";
import ArrowDownIcon from "../../assets/icons/arrowdown.svg";
import ArrowUpIcon from "../../assets/icons/arrowup.svg";
import AddIcon from "@mui/icons-material/Add";
import { DeleteOutline, Wifi } from "@mui/icons-material";
import { Avatar, Checkbox } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { axios } from "../../utils/axios";
import { useLocation } from "react-router-dom";
import CountdownTimer from "../../components/CountDownTimer";
import Loader from "../../components/Loader/index.jsx";
import { toast } from "react-toastify";
import TravellersModal from "../../components/TravellerModel/index.jsx";
import Modal from "../../components/Modal";
import Tooltip from "@mui/material/Tooltip";
import { formatDateToEEE_MM_d } from "../../utils/utils.jsx";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../components/stripPatyment.jsx";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedCurrency } from "../../redux/slices/currency";
const BookingReview = () => {
  const navigate = useNavigate();
  const roomDetailsRef = useRef(null);
  const [showRoomDetails, setShowRoomDetails] = useState(null);
  const url = useLocation();
  const [open, setOpen] = useState(false); // Modal visibility state
  const [travellerList, setTravellerList] = useState([
    { title: "Mr", firstName: "", lastName: "", email: "", phone: "", age: "" },
  ]);
  const [hoteldetails, setHotelDetails] = useState([]);
  const [tripDetails, setTripDetails] = useState();
  const [travellers, setTravellers] = useState([]);
  const [billingDetails, setBillingDetails] = useState();
  const queryParams = new URLSearchParams(url.search);
  const tid = queryParams.get("tid") || null;
  const dispatch = useDispatch();
  const token = queryParams.get("tkid");
  const sid = queryParams.get("sid");
  const oc = JSON.parse(queryParams.get("oc"));
  const cid = JSON.parse(queryParams.get("cid"));
  const currency = queryParams.get("currency");
  const [loading, setLoading] = useState(false);
  const [terms, setTerms] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState({ status: false, data: null });
  const [stripePromise, setStripePromise] = useState(null);
  const [clientSecret, setClientSecret] = useState("");
  const [sbid, setSBid] = useState("");
  const [bookingDeatils, setBookingDeatils] = useState();
  // -------------Stripe---------------------
  const [paymentOpen, setPaymentOpen] = useState(false);
  const { currencies, selectedCurrency } = useSelector(
    (state) => state.currency
  );
  const toggleRoomDetails = (id) => {
    setShowRoomDetails((prevId) => (prevId === id ? null : id));
  };
  const addTravellers = (travellerList) => {
    if (!tid) {
      setOpen(false);
      setTravellers(travellerList);
    } else {
      axios
        .post(process.env.REACT_APP_BACKEND + "trip/addtravellers", {
          tripid: tid || null,
          travellers: travellerList,
        })
        .then((resp) => {
          setTravellers(resp.data.data);
          setOpen(false);
          toast.success(resp.data.message);
        })
        .catch((err) => {
          console.log(err);
          toast.error(err.response.data.message);
        });
    }
  };
  useEffect(() => {
    if (currencies.length > 0 && currency) {
      const currencyResult = currencies.find((item) => item.code === currency);
      if (currencyResult) {
        dispatch(setSelectedCurrency(currencyResult));
      }
    }
  }, [currencies, currency, dispatch]);
  useEffect(() => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY));
    const totalCount = oc?.adults + oc?.children?.length;
    const peopleArray = Array.from({ length: totalCount }, () => ({
      title: "Mr",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      age: "",
    }));
    setTravellerList(peopleArray);

    getBookingDetails();
    getBillingDetails();
  }, []);
  const getBookingDetails = () => {
    let url = `${process.env.REACT_APP_BACKEND}reviewbooking/getbookingreview`;
    const params = new URLSearchParams();
    if (tid) {
      params.append("tripId", tid);
    }
    params.append("savedRoomId", sid);
    axios
      .get(`${url}?${params.toString()}`)
      .then((resp) => {
        setHotelDetails(resp.data.data?.hotelDetails);
        setTripDetails(resp?.data?.data?.tripDetails);
        if (resp?.data?.data?.travellers.length !== 0) {
          setTravellers(resp?.data?.data?.travellers);
        }
        if (resp?.data?.data?.travellers.length !== 0) {
          const travellers = resp?.data?.data?.travellers;
          const totalCount = oc?.adults + oc?.children?.length;
          if (travellers.length === totalCount) {
            setTravellerList(resp?.data?.data?.travellers);
          } else {
            const remainingCount = totalCount - travellers.length;
            const peopleArray = Array.from({ length: remainingCount }, () => ({
              title: "",
              firstName: "",
              lastName: "",
              email: "",
              phone: "",
              age: "",
            }));
            setTravellerList([...travellers, ...peopleArray]);
          }
        }
        if (resp.data.data?.hotelDetails.length === 0) {
          navigate(`/trip-planner?id=${tid}`);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getBillingDetails = () => {
    let baseUrl = `${process.env.REACT_APP_BACKEND}reviewbooking/getbillcard`;
    let queryParams = [];

    if (tid) {
      queryParams.push(`tripId=${tid}`);
    }

    queryParams.push(`savedRoomId=${sid}`);

    const fullUrl = `${baseUrl}?${queryParams.join("&")}`;

    axios
      .get(fullUrl)
      .then((resp) => {
        setBillingDetails(resp.data.data);
      })
      .catch((err) => {
        console.log(err);
        setBillingDetails(null);
      });
  };
  const bookHotel = () => {
    const hotelIds =
      hoteldetails &&
      hoteldetails.map((hotel) => {
        return hotel.id;
      });

    const hotelsoutput = hoteldetails.map((item) => ({
      hotelId: item.id,
      recommendationIds: item.rooms.map((room) => room.recommendationId),
    }));
    const data = {
      ...(tid && { tripId: tid }),
      ...(sid && { savedRoomId: sid }),
      cid: cid,
      travellers: travellers,
    };
    if (!terms) {
      toast.error("Please accept the terms and conditions");
    } else {
      setLoading(true);
      axios
        .post(process.env.REACT_APP_BACKEND_ZENTRUM + "stripecheckout", data)
        .then((resp) => {
          setLoading(false);
          setBookingDeatils(resp?.data);
          setClientSecret(resp?.data?.clientSecret);
          setSBid(resp?.data?.sevenlyBookingId);
          setPaymentOpen(true);

          // window.location.href = resp.data.url;
        })
        .catch((err) => {
          setLoading(false);
          setSBid("");
          setBookingDeatils("");
          setClientSecret("");
          toast.error(err.response.data.message);
          if (err?.response?.data?.modalOpen === true) {
            setOpen(true);
          }
        });
    }
  };
  const handleCheckboxClick = () => {
    setTerms(!terms);
  };
  const removeHotelFromTrip = () => {
    const data = {
      savedRoomId: deleteOpen?.data?.savedRoomId,
    };
    axios
      .post(
        process.env.REACT_APP_BACKEND + "reviewbooking/deletetriproom ",
        data
      )
      .then((resp) => {
        setDeleteOpen({ status: false, data: null });
        getBookingDetails();
        setShowRoomDetails(null);
        getBillingDetails();
        if (tid === "undefined") {
          navigate("/search-list");
        }
      })
      .catch((err) => console.log(err));
  };
  // ---------------Stripe new---------------------
  return (
    <div className="bgsearch">
      {loading && <Loader />}
      <div className="container py-5">
        <h1>Review your Booking</h1>
        <div className="row mt-4">
          <div className="col-md-8">
            {tid !== "undefined" && tid !== null && tid !== "" && (
              <div className="bxShadow p-3 rwcard-containers ">
                <h2>Trip Info</h2>
                <div className="d-flex align-items-center justify-content-between   ">
                  <div
                    className="d-flex align-items-center mt-3"
                    style={{ gap: "10px" }}
                  >
                    <img
                      src={tripDetails?.locationImg}
                      style={{
                        borderRadius: "5px",
                        width: "150px",
                        height: "150px",
                      }}
                      loading="lazy"
                    />

                    <div>
                      <h2 className="fw-700 ">{tripDetails?.tripName} Trip</h2>
                      {tripDetails?.startDate && (
                        <p
                          className="fs-8 my-1 ms-1"
                          style={{ color: "var(--grey-color)" }}
                        >
                          {formatDateToEEE_MM_d(tripDetails?.startDate, "UTC")}-
                          {formatDateToEEE_MM_d(tripDetails?.endDate, "UTC")}
                        </p>
                      )}
                      <p className="fs-6 green-pile">New trip</p>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {hoteldetails &&
              hoteldetails.map((rdata, index) => (
                <div
                  className="bxShadow p-3 mt-4 mb-5 rwcard-containers d-flex flex-column"
                  key={rdata._id}
                  style={{ position: "relative" }}
                  ref={roomDetailsRef}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <h2>{rdata?.name}</h2>
                    {tid && (
                      <p className="d-flex align-items-center">
                        <Tooltip title="Delete Hotel" placement="top" arrow>
                          <DeleteOutline
                            onClick={() =>
                              setDeleteOpen({ status: true, data: rdata })
                            }
                            className="c-pointer"
                          />
                        </Tooltip>
                      </p>
                    )}
                  </div>
                  <div className="row mt-3">
                    <div className="col-md-3">
                      <img
                        src={rdata?.heroImage}
                        className="imgclass"
                        style={{ borderRadius: "8px", height: "auto" }}
                        loading="lazy"
                      />
                    </div>
                    <div className="col-md-9">
                      <p>{rdata?.starRating} - star Hotel</p>
                      {/* <div className="d-flex align-items-center justify-content-between">
                      <h2>{rdata.hotel.name}</h2>
                      <p style={{ color: "var(--primary-color)" }}>
                        Hotel details
                      </p>
                    </div> */}
                      <p
                        className="fs-8"
                        style={{ color: "var(--grey-color)" }}
                      >
                        {rdata?.contact?.address?.line1}{" "}
                        {rdata?.contact?.address?.city?.name},{" "}
                        {rdata?.contact?.address?.country?.name}
                      </p>
                      {/* <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="d-flex align-items-center">
                          <p
                            style={{
                              background: "var(--black-color)",
                              color: "var(--white-color)",
                              borderRadius: "8px",
                              padding: "4px 6px",
                            }}
                          >
                            {rdata?.hotelDetails?.ratings}
                          </p>
                          <p
                            className="fs-8 ms-1"
                            style={{ color: "var(--grey-color)" }}
                          >
                            {rdata?.rcomment}
                          </p>
                          <p
                            className="fs-8 ms-2"
                            style={{ color: "var(--grey-color)" }}
                          >
                            ({rdata?.hotelDetails?.reviews})
                          </p>
                        </div>
                        <p>Duration: {rdata?.duration}</p>
                      </div> */}
                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="d-flex align-items-start justify-content-between">
                          <p style={{ color: "var(--grey-color)" }}>
                            Check In:
                          </p>
                          <div className="ms-1">
                            <p>
                              {formatDateToEEE_MM_d(
                                rdata?.checkIn,
                                "UTC",
                                "short"
                              )}
                            </p>
                            <p
                              className="fs-8"
                              style={{ color: "var(--grey-color)" }}
                            >
                              {/* {rdata?.checkOut} */}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-start justify-content-between">
                          <p style={{ color: "var(--grey-color)" }}>
                            Check Out:
                          </p>
                          <div className="ms-1">
                            <p>
                              {" "}
                              <p>
                                {formatDateToEEE_MM_d(
                                  rdata?.checkOut,
                                  "UTC",
                                  "short"
                                )}
                              </p>
                            </p>
                            <p
                              className="fs-8"
                              style={{ color: "var(--grey-color)" }}
                            >
                              {rdata?.check_out_time}
                            </p>
                          </div>
                        </div>
                      </div>
                      <p className="fs-6 mt-1">{rdata?.descriptions}</p>
                    </div>
                  </div>

                  <div
                    style={{
                      maxHeight:
                        showRoomDetails === rdata.savedRoomId
                          ? `${
                              roomDetailsRef.current?.scrollHeight *
                              rdata?.rooms.length
                            }px`
                          : "0",
                      overflow: "hidden",
                      transition: "all 0.6s ease",
                    }}
                  >
                    {showRoomDetails === rdata.savedRoomId && (
                      <>
                        <hr
                          className="my-4"
                          style={{
                            background: "var(--grey-color)",
                            height: "1px",
                          }}
                        />
                        {rdata?.rooms.map((room, index) => (
                          <div key={index}>
                            <div className="row mt-3">
                              <div className="col-md-3">
                                <img
                                  src={room.images}
                                  className="imgclass"
                                  style={{
                                    borderRadius: "8px",
                                    height: "auto",
                                  }}
                                  loading="lazy"
                                />
                              </div>
                              <div className="col-md-9">
                                <h4 className="mt-1">
                                  {room.name} * {room?.occupancies.length}
                                </h4>
                                <p className="fs-8">
                                  {room?.boardBasis?.type === "HalfBoard"
                                    ? "Includes breakfast and one additional meal "
                                    : room?.boardBasis?.type ===
                                      "BedAndBreakfast"
                                    ? "Includes breakfast"
                                    : room?.boardBasis?.description}
                                </p>
                                <p
                                  style={{
                                    color: room?.refundable
                                      ? "var(--primary-color)"
                                      : "var(--red-color)",
                                  }}
                                >
                                  {room?.refundable
                                    ? "Refundable"
                                    : "Non-Refundable"}
                                </p>
                                <p>{room[0]?.rules[0]?.end}</p>
                                {room?.refundable === true && (
                                  <>
                                    {/* <p className="fs-8">Refundable</p> */}
                                    <p className="fs-8">
                                      until{" "}
                                      {
                                        room?.cancellationPolicies?.[0]?.rules?.[0]?.end.split(
                                          "T"
                                        )[0]
                                      }{" "}
                                      {room?.cancellationPolicies?.[0]?.rules?.[0]?.end
                                        .split("T")[1]
                                        .split(":")
                                        .slice(0, 2)
                                        .join(":")}
                                    </p>
                                  </>
                                )}

                                {/* <h3 className="mt-1">{rdata.room.name}</h3> */}
                                {/* <p className="mt-1">{room.type}</p> */}
                                {/* <p
                                className="mt-1"
                                style={{ color: "var(--primary-color)" }}
                              >
                                Room Details
                              </p> */}
                                {room &&
                                  room?.cancellationPolicies &&
                                  room?.cancellationPolicies[0]?.rules &&
                                  room?.cancellationPolicies[0]?.rules
                                    .length !== 0 &&
                                  room?.refundability === "Refundable" && (
                                    <div>
                                      <hr className="mb-1 mt-3 hrColor" />

                                      <p
                                        style={{ color: "var(--yellow-color)" }}
                                      >
                                        Cancellation Policy
                                      </p>

                                      <p className="fs-8">
                                        •{" "}
                                        {room?.cancellationPolicies[0]?.rules[0]
                                          .value === 0
                                          ? "No cancellation fee "
                                          : ` A cancellation fee of  ${
                                              room?.cancellationPolicies[0]
                                                ?.rules[0].valueType ===
                                              "Percentage"
                                                ? `${room?.cancellationPolicies[0]?.rules[0].value}% of the total amount`
                                                : `$${room?.cancellationPolicies[0]?.rules[0].value.toFixed(
                                                    2
                                                  )}`
                                            }`}{" "}
                                        will be charged if you cancel between{" "}
                                        {
                                          room?.cancellationPolicies[0]?.rules[0].start.split(
                                            "T"
                                          )[0]
                                        }{" "}
                                        {room?.cancellationPolicies[0]?.rules[0].start
                                          .split("T")[1]
                                          .split(":")
                                          .slice(0, 2)
                                          .join(":")}{" "}
                                        and{" "}
                                        {
                                          room?.cancellationPolicies[0]?.rules[0].end.split(
                                            "T"
                                          )[0]
                                        }{" "}
                                        {room?.cancellationPolicies[0]?.rules[0].end
                                          .split("T")[1]
                                          .split(":")
                                          .slice(0, 2)
                                          .join(":")}
                                      </p>
                                      <p className="fs-8">
                                        •{" "}
                                        {room?.cancellationPolicies[0]?.rules[
                                          room?.cancellationPolicies[0]?.rules
                                            .length - 1
                                        ].value === 0
                                          ? "No cancellation fee "
                                          : ` 100% cancellation fee of  `}{" "}
                                        will be charged if you cancel after{" "}
                                        {
                                          room?.cancellationPolicies[0]?.rules[0].end.split(
                                            "T"
                                          )[0]
                                        }{" "}
                                        {room?.cancellationPolicies[0]?.rules[0].end
                                          .split("T")[1]
                                          .split(":")
                                          .slice(0, 2)
                                          .join(":")}
                                      </p>
                                    </div>
                                  )}
                                <hr className="mb-1 mt-3 hrColor" />
                                <p className="my-2 fs-8">
                                  {room?.additionalCharges &&
                                  room.additionalCharges.length > 0
                                    ? `A resort fee of 
       ${room.additionalCharges.reduce(
         (sum, item) => sum + (item?.charge?.amount || 0),
         0
       )} $ will be charged at the hotel`
                                    : ""}
                                </p>
                              </div>
                              {/* <div className="col-md-3">
                              {rdata?.room?.amenities.map((ramData) => (
                                <div
                                  className="d-flex align-items-center"
                                  key={ramData.name}
                                >
                                  <p
                                    className="mt-1"
                                    style={{ color: "var(--grey-color)" }}
                                  >
                                    {ramData.icon}
                                  </p>
                                  <p
                                    className="ms-2"
                                    style={{ color: "var(--grey-color)" }}
                                  >
                                    {ramData.name}
                                  </p>
                                </div>
                              ))}
                            </div> */}
                            </div>
                          </div>
                        ))}
                      </>
                    )}
                  </div>

                  {/* Centered arrow icon at the bottom */}
                  <div
                    className="text-center mt-auto"
                    style={{
                      marginTop: "auto",
                      position: "absolute",
                      bottom: "-30px",
                      left: "50%",
                      right: 0,
                    }}
                  >
                    <span
                      onClick={() => toggleRoomDetails(rdata?.savedRoomId)}
                      style={{ cursor: "pointer", fontSize: "24px" }}
                    >
                      {showRoomDetails === rdata.savedRoomId ? (
                        <>
                          <img
                            src={ArrowUpIcon}
                            style={{
                              background: "var(--white-color)",
                              borderRadius: "50px",
                              padding: "10px",
                              width: "20px",
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                            }}
                            loading="lazy"
                          />
                        </>
                      ) : (
                        <img
                          src={ArrowDownIcon}
                          style={{
                            background: "var(--white-color)",
                            borderRadius: "50px",
                            padding: "10px",
                            width: "20px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                          }}
                          loading="lazy"
                        />
                      )}
                    </span>
                  </div>
                </div>
              ))}

            {travellers.length !== 0 && (
              <div className="bxShadow  mt-3 p-3 rwcard-containers ">
                <h3> Traveler Name</h3>

                {travellers.map((t, index) => (
                  <div className="d-flex align-items-center mt-3" hey={index}>
                    <div className="me-2">
                      <Avatar sx={{ width: 50, height: 50 }}>
                        {" "}
                        {t.firstName[0]}{" "}
                      </Avatar>
                    </div>
                    <div>
                      <p>
                        <span> {t.title} </span>

                        <span>{t.firstName} </span>

                        {t.lastName}
                      </p>
                      <p className="fs-8"> {t.email}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="bxShadow  mt-3 rwcard-containers ">
              <h3 className="mb-4 p-3">Summary of Charges</h3>
              <div className="p-3">
                {billingDetails?.bill.map((bd, index) => (
                  <div
                    style={{ borderBottom: "1px solid var(--black-color)" }}
                    key={index}
                  >
                    <h5>{bd.hotelName}</h5>
                    {bd?.rooms.map((rb, index) => (
                      <div
                        className="d-flex align-items-center justify-content-between mt-2 pb-2"
                        key={index}
                      >
                        <p className="fs-8">
                          {rb?.roomName} x {rb?.quantity}
                        </p>
                        <p className="fs-8">
                          {selectedCurrency?.symbol ?? "$"}{" "}
                          {(rb?.total * selectedCurrency?.value ?? 1).toFixed(
                            2
                          )}
                        </p>
                      </div>
                    ))}
                  </div>
                ))}
                <div
                  className="d-flex align-items-center justify-content-between mt-3"
                  style={{ borderBottom: "1px solid var(--black-color)" }}
                >
                  <p className="fs-8">Tax Recovery Charges & Service Fees</p>
                  <p className="fs-8">
                    {billingDetails?.taxable_amount !== "0.00"
                      ? `$${billingDetails?.taxable_amount}`
                      : "Inclusive"}
                  </p>
                </div>
                <p className="fs-6">
                  This charge includes the estimated amount we pay the hotel for
                  occupancy related taxes owed by the hotel and any amounts
                  charged to us for resort fees, cleaning fees, and other fees.
                  The balance of the charge is a fee we, the hotel supplier
                  and/or the website you booked on, retain as part of the
                  compensation for our and/or their services which varies based
                  on factors such as location, the amount, and how you booked
                </p>
                <div className="d-flex align-items-center justify-content-between mt-2 pb-2">
                  <p className="fw-700">Total</p>
                  <div>
                    <p className="fw-700">
                      {selectedCurrency?.symbol ?? "$"}{" "}
                      {(
                        billingDetails?.final_amount_tax *
                          selectedCurrency?.value ?? 1
                      ).toFixed(2)}
                    </p>
                    <p
                      className="fw-700"
                      style={{ color: "var(--grey-color)", fontSize: "14px" }}
                    >
                      In USD: $ {billingDetails?.final_amount_tax}
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="p-3"
                style={{ backgroundColor: "var(--pile-green)" }}
              >
                <p className="fs-8 mt-3">
                  * This resort fee is subject to change.Please confirm with the
                  property if you will be charged this fee upon arrival.{" "}
                </p>
                <div className="d-flex align-items-center mt-2 ">
                  <Checkbox onClick={handleCheckboxClick} checked={terms} />
                  <p className="fs-8">
                    {" "}
                    I have read the payment information provided above about my
                    bookings
                  </p>
                </div>
                <div style={{ textAlign: "end" }}>
                  <button className="btn-outlined" onClick={bookHotel}>
                    Book now
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4   ">
            {tid !== "undefined" && tid !== null && tid !== "" && (
              <button
                className="btn-contained w100 mb-4 d-flex align-items-center justify-content-center"
                onClick={() => navigate(`/trip-planner?id=${tid}`)}
              >
                {" "}
                <AddIcon /> <p className="ms-2">Add a Hotel </p>
              </button>
            )}
            <button
              className="btn-contained w100 mb-4 d-flex align-items-center justify-content-center"
              onClick={() => {
                setOpen(true);
                // setTravellerList(travellers);
              }}
            >
              Add Traveler
            </button>
            <div className="bxShadow rwcard-containers sticky-column ">
              <div className="p-3">
                <h4> In this booking</h4>
                <div className="d-flex align-items-center justify-content-between mt-3">
                  <p>Rooms</p>
                  <p>{billingDetails?.totalRooms}</p>
                </div>

                {billingDetails?.hotelSummaries.map((bd, index) => (
                  <div
                    className="d-flex align-items-center justify-content-between mt-3"
                    key={index}
                  >
                    <div>
                      <p>{bd.hotelName}</p>
                      <p className="fs-8">Rooms x {bd.totalRooms}</p>
                    </div>
                    <p>
                      {selectedCurrency?.symbol ?? "$"} {""}
                      {(bd.totalPrice * selectedCurrency?.value ?? 1).toFixed(
                        2
                      )}{" "}
                    </p>
                  </div>
                ))}

                <div className="d-flex align-items-center justify-content-between mt-3">
                  <p>Tax Recovery Charges & Service Fees</p>
                  <p>
                    {" "}
                    {billingDetails?.taxable_amount !== "0.00"
                      ? `$${billingDetails?.taxable_amount}`
                      : "Inclusive"}
                  </p>
                </div>
                <p className="fs-6">
                  This charge includes the estimated amount we pay the hotel for
                  occupancy related taxes owed by the hotel and any amounts
                  charged to us for resort fees, cleaning fees, and other fees.
                  The balance of the charge is a fee we, the hotel supplier
                  and/or the website you booked on, retain as part of the
                  compensation for our and/or their services which varies based
                  on factors such as location, the amount, and how you booked
                </p>
                <hr
                  className="my-3"
                  style={{ backgroundColor: "var(--grey-color", height: "1px" }}
                />
                <div className="d-flex align-items-center justify-content-between ">
                  <p>Total</p>
                  <div>
                    <p className="fw-700">
                      {selectedCurrency?.symbol || "$"}
                      {(
                        billingDetails?.final_amount_tax *
                          selectedCurrency?.value ?? 1
                      ).toFixed(2)}
                    </p>

                    <p
                      className="fw-700"
                      style={{ color: "var(--grey-color)", fontSize: "14px" }}
                    >
                      In USD: $ {billingDetails?.final_amount_tax}
                    </p>
                  </div>
                </div>
                <p className="fs-8 mt-2">
                  For a full price breakdown, see the summary of charges at the
                  bottom of checkout.
                </p>
              </div>
              <div
                className="p-3"
                style={{
                  backgroundColor: "var(--pile-green)",
                  borderBottomLeftRadius: "8px",
                  borderBottomRightRadius: "8px",
                }}
              >
                <div className="d-flex align-items-center justify-content-between ">
                  <p>Time left to book</p>
                  <CountdownTimer initialMinutes={15} />
                </div>
                <p className="fs-8 mt-2">
                  Book before the timer runs out to secure this rate. If the
                  timer expires, you'll need to run your search again.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <TravellersModal
        open={open}
        setOpen={setOpen}
        travellerList={travellerList}
        setTravellerList={setTravellerList}
        addTravellers={addTravellers}
        hide={true}
      />
      <Modal
        open={deleteOpen?.status}
        onClose={() => setDeleteOpen({ status: false, data: null })}
        title="Delete Hotel"
        size="sm"
      >
        <p className="mt-4">
          Are you sure you want to delete the hotel from trip?
        </p>
        <div
          className="mt-4 d-flex alifn-items-center justify-content-end"
          style={{ gap: 20 }}
        >
          <button
            className="btn-outlined"
            onClick={() => setDeleteOpen({ status: false, data: null })}
          >
            Cancel
          </button>
          <button className="btn-contained" onClick={removeHotelFromTrip}>
            Confirm
          </button>
        </div>
      </Modal>

      <Modal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        title="Hotel Payment"
        size="md"
      >
        <div className="row p-2">
          <div className="col-md-7">
            {hoteldetails &&
              hoteldetails.map((rdata, index) => (
                <div
                  className="bxShadow p-3    d-flex flex-column"
                  key={rdata._id}
                  style={{ borderRadius: "8px" }}
                  ref={roomDetailsRef}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <h2>{rdata?.name}</h2>
                  </div>
                  <div className="row mt-3">
                    {/* <div className="col-md-3"> */}
                    {/* <img
                        src={rdata?.heroImage}
                        className="imgclass"
                        style={{ borderRadius: "8px", height: "auto" }}
                      /> */}
                    {/* </div> */}
                    <div className="col-md-12">
                      <p>{rdata?.starRating} - star Hotel</p>

                      <p
                        className="fs-8"
                        style={{ color: "var(--grey-color)" }}
                      >
                        {rdata?.kms} {rdata?.contact?.address?.line1}
                      </p>

                      <div className="d-flex align-items-center justify-content-between mt-2">
                        <div className="d-flex align-items-start justify-content-between">
                          <p style={{ color: "var(--grey-color)" }}>
                            Check In:
                          </p>
                          <div className="ms-1">
                            <p>
                              {formatDateToEEE_MM_d(
                                rdata?.checkIn,
                                "UTC",
                                "long"
                              )}
                            </p>
                            <p
                              className="fs-8"
                              style={{ color: "var(--grey-color)" }}
                            ></p>
                          </div>
                        </div>
                        <div className="d-flex align-items-start justify-content-between">
                          <p style={{ color: "var(--grey-color)" }}>
                            Check Out:
                          </p>
                          <div className="ms-1">
                            <p>
                              {" "}
                              <p>
                                {formatDateToEEE_MM_d(
                                  rdata?.checkOut,
                                  "UTC",
                                  "long"
                                )}
                              </p>
                            </p>
                            <p
                              className="fs-8"
                              style={{ color: "var(--grey-color)" }}
                            >
                              {rdata?.check_out_time}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            <div
              className="d-flex align-items-center mt-4 justify-content-between bxShadow p-3"
              style={{ borderRadius: "8px" }}
            >
              {" "}
              <p className="fw-700">Total Amount</p>
              <div>
                <p className="fw-700">
                  {" "}
                  {selectedCurrency?.symbol || "$"}{" "}
                  {(
                    bookingDeatils?.totalAmount * selectedCurrency?.value ?? 1
                  ).toFixed(2)}
                </p>
                <p
                  className="fw-700"
                  style={{ color: "var(--grey-color)", fontSize: "14px" }}
                >
                  In USD:${bookingDeatils?.totalAmount}
                </p>
              </div>
            </div>
          </div>

          <div
            className="col-md-5 bxShadow py-3  "
            style={{ borderRadius: "8px" }}
          >
            <Elements stripe={stripePromise} options={{ clientSecret }}>
              <CheckoutForm tid={tid} bid={sbid} />
            </Elements>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default BookingReview;
